// extracted by mini-css-extract-plugin
module.exports = {"card":"Aircraft_card__1-59q","image":"Aircraft_image__nhBO3","sky":"Aircraft_sky__1cpZ1","water":"Aircraft_water__AFjrZ","name":"Aircraft_name__30MGm"};